import type { FaireProductEntity } from "../../entity_types/product";

export const p_9zv93u4qq8: FaireProductEntity = {
  token: "p_9zv93u4qq8",
  type: "product",
  name: "Coquette Cowgirl Western Women's Lounge Set - Mommy and Me",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/65f555a5424bf796edbe4872f6e15a2121c42843c52e35a2b0b449f0fd349749.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eff5e72fcf505ee82300bbdeca20632366493087acae2131aceb413bc2670372.jpeg",
    "https://cdn.faire.com/fastly/41499fe1ec5194176bd7022788c4041ccccb41dbb06968a7c7fcdee132897893.jpeg",
  ],
  priceDollars: 36,
  description:
    "Sweet dreams meet southern charm in this cozy lounge set, designed with playful western vibes perfect for winding down in style.\n\nFeatures:\n * Set Color: Soft pink and ivory \n * Graphic Color: Multicolor \n * Material: 96% Polyester/4% Spandex \n * Features: Super soft; shorts have front slant pockets; tagless inside neck label for an itch-free wear \n * Fit: Snug fit \n * Care: Machine wash cold, dry flat, not flame resistant \n\nEach lounge set is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:27.709Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
